document.addEventListener("DOMContentLoaded", () => {
  const locale = Shopify.locale;

  const localeMap = {
    en: "English",
    es: "Español"
  };

  const targetVariant = localeMap[locale];

  if (!targetVariant) return;

  const radio = document.querySelector(
    `input[type="radio"][value="${targetVariant}"]`
  );

  if (!radio) return;

  if (!radio.checked) {
    radio.click();
    console.log("Variante seleccionada automáticamente:", targetVariant);
  }
});